import React, { useRef } from "react";
import { GridController, GridTable } from "@ctsu/ctsu-mui-grid";
import { getToken } from "@ctsu/loader";
import { useCurrentUser } from "protocol-setup/helpers/useIsCTSUUser";
import {
  FORM_HISTORY_COLUMNS,
  formatHistoryData,
  generateDynamicOptions,
  updateLovValuesToSnakeCase
} from "./requestHistoryUtils";
import {
  TAB_UPDATED_OPTIONS,
  TAB_UPDATED_REGULATORY_OPTIONS
} from "./requestHistoryLovs";



const RequestFormHistory = ({
  requestHistory,
  isLoading,
  error,
  formPartType,
  requestNumber
}) => {
  const currentUser = useCurrentUser();
  const gridController = useRef(GridController.createController());

 

  // Format the data first
  const formattedData = formatHistoryData(requestHistory);

  // Determine which Tab Updated LOV to use based on formPartType
  const tabUpdatedOptions =
    formPartType === "REGULATORY"
      ? TAB_UPDATED_REGULATORY_OPTIONS
      : TAB_UPDATED_OPTIONS;

  // Generate dynamic options for Updated By
  const updatedByOptions = generateDynamicOptions(
    formattedData,
    ["updatedBy", "changedBy"],
    ["N/A"]
  );

   const updatedByOptionsSnakeCase = React.useMemo(
    () => updateLovValuesToSnakeCase(updatedByOptions),
    [updatedByOptions]
  );

  // Create columns with dynamic options and custom filter component
  const columnsWithDynamicOptions = FORM_HISTORY_COLUMNS.map((col) => {
    if (col.name === "tabUpdated") {
      return {
        ...col,
        type: "object",
        options: tabUpdatedOptions
      };
    }
    if (col.name === "updatedByFormatted") {
      return {
        ...col,
        type: "multi",
        options: updatedByOptionsSnakeCase,
        renderCell : (data) => <>{data.updatedBy}</>
      };
    }
    return col;
  });


   if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center p-4"
        data-testid="loading-container"
      >
        <div
          className="spinner-border"
          role="status"
          data-testid="loading-spinner"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Error loading request form history: {error.message}
      </div>
    );
  }

  return (
    <GridTable
      id="form-history-grid"
      columns={columnsWithDynamicOptions}
      rows={formattedData}
      toPdf={false}
      filterable
      sortable
      showFilterByDefault={false}
      enableToolbar
      recordPerPage={10}
      getToken={getToken}
      controller={gridController.current}
      defaultSorts={[{ field: "updatedDate", dir: "desc" }]}
      tag="request-form-history"
      enableInfiniteScroll={false}
      nonExportable={["updatedByFormatted", "id"]}
      user={currentUser}
      exportTitle={`Protocol Setup Request History ${requestNumber}`}
    />
  );
};

export default RequestFormHistory;
